<template>
  <div class="hours grid-size white-bg sticky top-0 z3">
    <ul class="d-flex">
      <li v-for="hour in hours" :key="`hour_${hour}`" :style="`width:${width}`">
        <div class="d-flex align-center full-height">
          <span class="font-weight-bold">
            {{ hour }}
            <span v-if="hour !== '00h'">
              <v-icon v-if="parseInt(hour) === hourSelected && showSort" button @click="clearSort">mdi-arrow-down-thick</v-icon>
              <v-icon v-else-if="parseInt(hour) !== hourSelected && showSort" button @click="hourSorting(hour)">mdi-arrow-up-thick</v-icon>
            </span>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api';

export default {
  props: {
    width: {
      type: String,
      default: '6.18%'
    },
    showSort: {
      type: Boolean,
      default: false
    },
    hourSort: {
      type: Number,
      default: null
    }
  },
  setup (props, context) {
    const hours = ['8h', '9h', '10h', '11h', '12h', '13h', '14h', '15h', '16h', '17h', '18h', '19h', '20h', '21h', '22h', '23h', '00h'];
    const hourSelected = ref(null);

    const hourSorting = hour => {
      hourSelected.value = parseInt(hour);
    };

    const clearSort = () => {
      hourSelected.value = null;
    };

    watch(hourSelected, () => {
      context.emit('sortHour', hourSelected.value);
    });

    watch(() => props.hourSort, newValue => {
      hourSelected.value = newValue;
    });

    return { clearSort, hourSorting, hourSelected, hours };
  }
};
</script>
